// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class UnregisteredLocationCoordinatesRecord extends VerofreshRecord {
  static get endpoint () { return 'location/unregistered-coordinates' }
}
export default UnregisteredLocationCoordinatesRecord
